import { onMounted, onUnmounted, ref } from 'vue';

export const BREAKPOINTS = {
  '2XL': 1536,
  LG: 1024,
  MD: 768,
  SM: 640,
  XL: 1280,
};

export function useViewportSize() {
  const browserWidth = ref(window.innerWidth);
  const deviceWidth = ref(screen.width);
  const isSmall = ref(browserWidth.value < BREAKPOINTS.SM);
  const isMedium = ref(browserWidth.value >= BREAKPOINTS.SM && browserWidth.value < BREAKPOINTS.MD);
  const isMobile = ref(browserWidth.value < BREAKPOINTS.MD);
  const isDesktop = ref(browserWidth.value >= BREAKPOINTS.MD);
  const isLarge = ref(browserWidth.value >= BREAKPOINTS.LG);
  const isXLarge = ref(browserWidth.value >= BREAKPOINTS['2XL']);
  const isTouch = ref(false);

  const browserResized = () => {
    browserWidth.value = window.innerWidth;
    deviceWidth.value = screen.width;
    isSmall.value = browserWidth.value < BREAKPOINTS.SM;
    isMedium.value = browserWidth.value >= BREAKPOINTS.SM && browserWidth.value < BREAKPOINTS.MD;
    isLarge.value = browserWidth.value >= BREAKPOINTS.LG;
    isXLarge.value = browserWidth.value >= BREAKPOINTS['2XL'];
    isMobile.value = browserWidth.value < BREAKPOINTS.MD;
    isDesktop.value = browserWidth.value >= BREAKPOINTS.MD;
  };

  onMounted(() => {
    isTouch.value = window.matchMedia('(pointer: coarse)').matches;
    window.addEventListener('resize', browserResized);
    browserResized();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', browserResized);
  });

  return {
    browserWidth,
    deviceWidth,
    isDesktop,
    isLarge,
    isMedium,
    isMobile,
    isSmall,
    isTouch,
    isXLarge,
  };
}
